import { valueType } from "@/hooks/useLocalStorage";
import { parseISO, addWeeks, isBefore } from "date-fns";

const LAST_SEEN_PROMPT_EXPIRATION_IN_WEEKS = 4;
const RECENT_FITNESS_TEST_EXPIRATION_IN_WEEKS = 12;

function shouldShowFitnessAssessmentPrompt(
  lastFitnessTestDate: string | undefined,
  lastSeenPromptDate: valueType
): boolean {
  if (!lastFitnessTestDate) {
    return false;
  }

  const currentDate = new Date();

  const lastTestOlderThanTwelveWeeks = isBefore(
    parseISO(lastFitnessTestDate),
    addWeeks(currentDate, -RECENT_FITNESS_TEST_EXPIRATION_IN_WEEKS)
  );

  if (lastTestOlderThanTwelveWeeks) {
    if (lastSeenPromptDate === null || lastSeenPromptDate === undefined) {
      return true;
    }

    if (typeof lastSeenPromptDate !== "string") {
      console.error("invalid lastSeenPromptDate type:", typeof lastSeenPromptDate);
      return false;
    }

    const lastSeenPromptOlderThanFourWeeks = isBefore(
      parseISO(new Date(lastSeenPromptDate).toISOString()),
      addWeeks(currentDate, -LAST_SEEN_PROMPT_EXPIRATION_IN_WEEKS)
    );

    return lastSeenPromptOlderThanFourWeeks;
  }

  return false;
}

export default shouldShowFitnessAssessmentPrompt;
